module.exports = __webpack_public_path__ + "static/media/size-39.afd0d613.jpg";